import { styled } from 'styled-components';

import AlertThresholdsForm from 'src/components/AlertSettingsComponents/AlertThresholdsForm';

export const StyledWrapper = styled.div``;

export const StyledAlertThresholdsForm = styled(AlertThresholdsForm)`
  column-gap: 2rem;
`;
